import { ExternalLink } from 'lucide-react';
import { CopyButton } from '@authe/ui-core';
import { getFactLink, factLinkHref, shortenCompositeIdentifier } from '@authe/fe-commons/chains';
import { isEnriched, rawOf, displayOf } from '@authe/fe-commons/storage';
import { jsxs, jsx } from 'react/jsx-runtime';

// src/components/IdentifierFact.tsx
function identifierText(value) {
  const inner = isEnriched(value) ? rawOf(value) ?? displayOf(value) : value;
  if (typeof inner === "string") return inner.trim();
  if (typeof inner === "number" || typeof inner === "bigint") return String(inner);
  return "";
}
function IdentifierFact({ protocolId, fact, value }) {
  const text = identifierText(value);
  if (!text) return null;
  const link = getFactLink(protocolId, fact);
  const href = link ? factLinkHref(link, text) : null;
  const short = shortenCompositeIdentifier(text);
  return /* @__PURE__ */ jsxs("span", { className: "inline-flex min-w-0 items-center gap-1 align-middle", children: [
    href && link ? /* @__PURE__ */ jsxs(
      "a",
      {
        href,
        target: "_blank",
        rel: "noopener noreferrer",
        title: `${text} \u2014 view on ${link.explorer}`,
        "data-explorer": link.explorer,
        className: "inline-flex items-center gap-1 font-mono text-xs text-primary hover:underline",
        children: [
          /* @__PURE__ */ jsx("span", { className: "break-all", children: short }),
          /* @__PURE__ */ jsx(ExternalLink, { className: "size-3 shrink-0", "aria-hidden": true })
        ]
      }
    ) : /* @__PURE__ */ jsx("span", { className: "break-all font-mono text-xs", title: text, children: short }),
    /* @__PURE__ */ jsx(CopyButton, { value: text })
  ] });
}
function identifierFactValue(protocolId, fact) {
  function IdentifierFactValue({ raw, display, decoded }) {
    return /* @__PURE__ */ jsx(IdentifierFact, { protocolId, fact, value: raw ?? display ?? decoded });
  }
  IdentifierFactValue.displayName = `IdentifierFact(${protocolId}.${fact})`;
  return IdentifierFactValue;
}

export { IdentifierFact, identifierFactValue, identifierText };
//# sourceMappingURL=chunk-OAF4WNMT.js.map
//# sourceMappingURL=chunk-OAF4WNMT.js.map